import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
// Import all CSS modules in the same order as parent to ensure consistent webpack ordering
// eslint-disable-next-line no-unused-vars
import _complainStyles from '../complain.module.css';
// eslint-disable-next-line no-unused-vars
import _deleteModalStyles from './delete.module.css';
// eslint-disable-next-line no-unused-vars
import _statusChangeStyles from './statusChange.module.css';
// eslint-disable-next-line no-unused-vars
import _viewStudentStyles from './viewStudent.module.css';
import styles from './reject_complaint.module.css';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

const RejectModal = ({ open, onClose, onConfirm, complaint }) => {
  const [remark, setRemark] = useState('');
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (complaint) {
      setSelectedComplaint(complaint);
    }
  }, [complaint]);

  if (!open) return null;
  
  const handleReject = async () => {
    try {
      if (!remark) {
        toast.error('Remark cannot be empty.');
        return;
      }
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/hospital/complaint/${selectedComplaint.id}/reject`,
        {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('Token')}`
        },
        body: JSON.stringify({ remark })
      });

      if (!response.ok) {
        throw new Error('Failed to reject complaint');
      }
      toast.success('Complaint rejected successfully.');
      onConfirm && onConfirm();
      onClose();
      setRemark('');
    } catch (err) {
      console.error('Error rejecting request:', err);
      setError('Failed to reject request');
      toast.error('Failed to reject request');
    }
  };

  return (
    <Box className={styles.rejectModal} onClick={onClose}>
      <Box className={styles.rejectModalContent} onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <Box className={styles.rejectModalHeader}>
          <Typography className={styles.rejectModalTitle}>Reject Complaint Request</Typography>
          <IconButton
            className={styles.rejectCloseButton}
            onClick={() => {
              onClose();
              setRemark('');
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Modal Content */}
        <Box className={styles.rejectModalBody}>
          <Typography className={styles.rejectConfirmationText}>Are you sure you want to reject this complaint?</Typography>

          <Typography className={styles.rejectWarningText}>This action cannot be undone.</Typography>

          <Box className={styles.rejectRemarkSection}>
            <Typography className={styles.rejectRemarkLabel}>Remark</Typography>
            <textarea
              id="remark"
              name="remark"
              placeholder="Enter remark"
              className={styles.rejectRemarkTextarea}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Box>

        {/* Modal Footer */}
        <Box className={styles.rejectModalFooter}>
          <Button className={styles.rejectCancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button className={styles.rejectConfirmButton} onClick={handleReject}>
            Yes, Reject
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RejectModal;
